export enum ContactFormType {
  Contact = "Contact",
  BidRequest = "Bid Request",
  Careers = "Careers",
}

export interface ContactForm {
  type: ContactFormType;
  hpName: string;
  fields: Record<string, string>;
  file?: string; 
}
